import React, { type ReactNode } from "react";
import * as styles from "src/components/SelectV2/SelectV2.style.ts";
import { ChipV2 } from "src/components/ChipV2/ChipV2.tsx";
import type { Option } from "src/components/SelectV2/SelectV2.types.ts";
import { SpinnerSpinningMini as Spinner } from "src/lib/ui-icon-v2";

type MultiplePreviewProps<Value = unknown> = {
  value: Value[] | "";
  flatOptions: Option<Value>[];
  onValueChange: (value: Value[] | "") => void;
  placeholder?: ReactNode;
  isLoadingData?: boolean;
  isOpen: boolean;
  isLoadingSelectedOption: boolean;
  fallbackOptions: Option<NoInfer<Value>>[];
  truncateOptions?: boolean;
  onOpen: (state: boolean) => void;
  disabled: boolean;
};
export const MultiplePreview = <Value = unknown,>(
  props: MultiplePreviewProps<Value>,
) => {
  const { value, truncateOptions = false, disabled } = props;
  const hasSelectOptions = Array.isArray(value) && value.length > 0;

  return (
    <div
      css={styles.multiSelectPreviewContainer({
        truncateOptions: truncateOptions,
        disabled,
        hasValue: hasSelectOptions,
      })}
    >
      <Inner {...props} />
    </div>
  );
};

const Inner = <Value = unknown,>({
  value,
  flatOptions,
  onValueChange,
  placeholder,
  isLoadingSelectedOption,
  fallbackOptions,
  truncateOptions = false,
  disabled,
  onOpen,
}: MultiplePreviewProps<Value>) => {
  const hasSelectOptions = Array.isArray(value) && value.length > 0;

  if (isLoadingSelectedOption) {
    return <Spinner />;
  }
  if (hasSelectOptions) {
    return (value || []).map((elementValue, index) => {
      const selectedOption = [...flatOptions, ...fallbackOptions].find(
        (o) => o.value === elementValue,
      );
      return (
        <ChipV2
          key={index}
          label={selectedOption?.label}
          disabled={disabled}
          // hoverable={false}
          css={styles.chip({ truncateOptions, disabled })}
          onPointerDown={(ev) => {
            ev.stopPropagation();
          }}
          onClick={(ev) => {
            ev.stopPropagation();
            onOpen(true);
          }}
          onDelete={() => {
            const nextValues = value.filter((o) => elementValue !== o);
            onValueChange(nextValues);
          }}
        />
      );
    });
  }
  return <div css={styles.placeholderText}>{placeholder}</div>;
};
